const styles = {
  grid: {
    height: '100%',
    backgroundColor: '#f7f8f9',
    justifyContent: 'center !important',
    marginTop: '3rem !important',
  },

  column: {
    width: '32% !important',
  },

  header: {
    color: '#683caf !important',
    fontSize: '3.1875rem !important',
    fontWeight: '300 !important',
    textAlign: 'center !important',
  },

  logo: {
    display: 'flex !important',
    justifyContent: 'center !important',
  },

  container: {
    backgroundColor: '#fff !important',
    borderRadius: '.375rem !important',
    border: 'none !important',
    boxShadow: '0 .125rem .375rem 0 rgba(0,0,0,0.05) !important',
    margin: '.625rem 0 !important',
    padding: '.625rem !important',
    width: '100% !important',
    position: 'relative !important',
  },

  field: {
    marginBottom: '1.5rem !important',
    '@global': {
      '.ui.form .field .prompt.label': {
        color: 'green !important',
      },
      '.ui.pointing.label': {
        border: 'none !important',
      },
      '.prompt.label': {
        border: 'none !important',
        marginTop: '0',
      },
      '.ui.pointing.label::before': {
        display: 'none',
      },
    },
  },

  showError: {
    display: 'flex !important',
  },

  backNavLink: {
    border: 'none !important',
    background: 'none !important',
    color: '#009bf6 !important',
    fontSize: '.75rem !important',
    fontWeight: '300 !important',
    padding: '0 !important',
  },

  signUpForm: {
    marginTop: '10rem !important',
  },

  button: {
    backgroundColor: '#683caf !important',
    borderRadius: '1.5em !important',
    color: '#fff !important',
    marginTop: '4.4375rem !important',
    height: '3.125rem',
    fontSize: '.9375rem',
  },
  buttonSecond: {
    margin: '0 !important',
    backgroundColor: '#a9b8c2 !important',
  },
  '@global': {
    '.fade-enter': {
      opacity: 0,
      zIndex: 1,
    },
    '.fade-enter.fade-enter-active': {
      opacity: 1,
      transition: 'opacity 250ms ease-in',
    },
    '.ui.form .field .prompt.label': {
      border: 'none !important',
    },
  },
  announcement: {
    marginTop: '4.4375rem !important',
    height: '1.525rem',
    fontSize: '1.12rem',
    fontWeight: '300 !important',
  },
};

export default styles;
